@if ({ isMobile: isMobile$ | async, availableFilters: availableFilters$ | async,
skeletonFilters: skeletonFilters$ | async, loadedFilter: loadedFilter$ | async,
selectFilterLoadError: selectFilterLoadError$ | async, activeAccountCurrency:
activeAccountCurrency$ | async, activeFilters: activeFilters$ | async,
filterColorKey: filterColorKey$ | async, filterColorValues: filterColorValues$ |
async}; as ctx) { @if (!ctx.loadedFilter && !ctx.selectFilterLoadError) {
<epc-filters-load-skeleton
  [filters]="
    ctx.availableFilters?.length > 0
      ? ctx.availableFilters
      : ctx.skeletonFilters
  "
></epc-filters-load-skeleton>
} @if (!!ctx.loadedFilter && !!ctx.selectFilterLoadError) {
<epc-filters-load-error
  class="d-flex h-100 justify-content-center"
  (refresh)="onLoadFilters()"
></epc-filters-load-error>
} @if (!!ctx.loadedFilter && !ctx.selectFilterLoadError) {
<ng-container *ngTemplateOutlet="filtersLoadedTmp"></ng-container>
}

<!-- Templates are below -->
<ng-template #filtersLoadedTmp>
  @for ( filter of ctx.availableFilters; track trackByIndex($index); let last =
  $last;) { @let isTitleHidden =
  hiddenFilterTitleIds().includes(filter.fieldId); @let isForceOpened =
  openedFilterIds().includes(filter.fieldId); @let isCollapseEnabled =
  filter.collapse?.enabled && !isForceOpened && !disableCollapse() &&
  !isTitleHidden;
  <div
    class="d-flex flex-column filter-container"
    [class.mb-1]="!last"
    [attr.data-e2e]="'filter-' + filter.fieldId"
  >
    @if (isCollapseEnabled) {
    <atx-accordion #accordionRef>
      <atx-accordion-panel
        [animate]="true"
        [panelId]="filter.fieldId"
        (toggled)="openedFields[filter.fieldId] = $event.open"
        [open]="openedFields[filter.fieldId]"
        [content]="accordionContentRef"
      >
        <atx-accordion-header>
          <h6 class="text-dark mb-0 cursor-pointer" data-e2e="filter-name">
            {{ filter | filterDisplayName }}
            <fa-icon
              class="filter-name__arrow d-inline-block ml-1"
              [class.active]="accordionRef.panelState[0]?.state"
              [icon]="['fas', 'angle-right']"
            ></fa-icon>
          </h6>
        </atx-accordion-header>
      </atx-accordion-panel>
      <ng-template #accordionContentRef>
        <ng-container
          *ngTemplateOutlet="filterTmp; context: { $implicit: filter }"
        ></ng-container>
      </ng-template>
    </atx-accordion>
    } @else { @if (!isTitleHidden) {
    <h6 class="text-dark mb-0" data-e2e="filter-name">
      {{ filter | filterDisplayName }}
    </h6>
    }
    <ng-container
      *ngTemplateOutlet="filterTmp; context: { $implicit: filter }"
    ></ng-container>
    }
  </div>
  }
</ng-template>
<ng-template #filterTmp let-filter>
  <div class="d-flex flex-wrap mt-1">
    @switch (true) { @case (filter.values?.length < 1 && filter.type != 'Group'
    && !filter.emptyInitialValues && !isDateRangeFilter(filter)) {
    <p
      class="text-muted mt-2"
      i18n="
        filters|Filters not available after selectiın@@filterValuesEmptyState"
    >
      No
      {{ filter | filterDisplayName | lowercase }}
      is available for this selection
    </p>
    } @case (isFilterColor(filter, ctx.filterColorKey)) {
    <div class="d-flex flex-wrap">
      @for (item of filter.values; track item; let last = $last) {
      <epc-products-filter-color
        (colorClick)="toggleFilter(filter.fieldId, item.value)"
        [active]="isFilterActive(filter.fieldId, item.value) | async"
        [disabled]="isFilterDisabled(filter.fieldId) | async"
        [color]="getFilterColorValue(ctx.filterColorValues, item.value)"
        [class.mr-3]="!last"
        class="my-1"
        [atxTooltip]="filter | filterValueDisplayName: item"
        tooltipPlacement="top"
      ></epc-products-filter-color>
      }
    </div>
    } @case (isRangeFilter(filter)) {
    <epc-products-filter-range
      [rangeFilters]="filter.subFilters ?? [filter]"
      [activeFilter]="
        activeRangeFilter(
          filter.fieldId,
          ctx.activeFilters,
          ctx.availableFilters
        )
      "
      [unit]="getRangeFilterUnit(filter, ctx.activeAccountCurrency)"
      [rangeGroupName]="filter.fieldId"
      [multiRangeSliderInputs]="multiRangeSliderInputs$ | async"
      (rangeChanged)="toggleFilter($event.fieldId, $event.value)"
    ></epc-products-filter-range>
    } @case (isDateRangeFilter(filter)) {
    <epc-products-filter-date-range
      [filter]="filter"
      [activeFilters]="
        getActiveFiltersByFieldId(filter.fieldId, ctx.activeFilters)
      "
      (dateRangeChanged)="
        toggleFilter($event.fieldId, $event.value, $event.dataType)
      "
    ></epc-products-filter-date-range>
    } @default { @for (item of filter.values; track item) { @if ({ icon:
    getFilterIconValue(filter.fieldId, item.value) | async, active:
    isFilterActive(filter.fieldId, item.value, filter.mergeValues) | async,
    disabled: (isFilterDisabled(filter.fieldId) | async) }; as ctx) {
    <button
      (click)="toggleFilter(filter.fieldId, item.value, filter.linkedFields)"
      [ngClass]="{
        'with-icon pr-2': ctx.icon,
        'rounded-pill': filter.isMultiple,
        active: ctx.active,
        'is-preset': filter.fieldId === 'preset'
      }"
      class="btn filter d-inline-flex align-items-center"
      [disabled]="ctx.disabled || (item.disabled && !ctx.active)"
      [attr.data-e2e]="'filter-value-' + (item.displayName | titlecase)"
    >
      @if (ctx.icon) {
      <div
        class="mr-1 d-flex justify-content-center align-items-center rounded-circle filter-icon"
      >
        <atx-custom-icon
          [icon]="ctx.icon"
          [path]="spritesPaths.FILTER"
          size="md"
          class="d-flex"
        ></atx-custom-icon>
      </div>
      }
      <span
        [attr.data-e2e]="'filter-value-name-' + (item.displayName | titlecase)"
        >{{ filter | filterValueDisplayName: item }}</span
      >
      @if (item.count !== null) {
      <span class="filter-count ml-1">({{ item.count }})</span>
      }
      <fa-icon class="cross-icon" [icon]="['fas', 'xmark']"></fa-icon>
    </button>
    } } } }
  </div>
</ng-template>
}
